import { render } from "./WorkbooksBundle.vue?vue&type=template&id=33b8c4b4&scoped=true"
import script from "./WorkbooksBundle.vue?vue&type=script&lang=js"
export * from "./WorkbooksBundle.vue?vue&type=script&lang=js"

import "./WorkbooksBundle.vue?vue&type=style&index=0&id=33b8c4b4&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b8c4b4"],['__file',"src/views/post/WorkbooksBundle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33b8c4b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33b8c4b4', __exports__)) {
    console.log('reload')
    api.reload('33b8c4b4', __exports__)
  }
  
  module.hot.accept("./WorkbooksBundle.vue?vue&type=template&id=33b8c4b4&scoped=true", () => {
    console.log('re-render')
    api.rerender('33b8c4b4', render)
  })

}


export default __exports__